// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2vMfr","content":"GlobalSearch_content__1QPAm"};